(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-thumb-hover"] && !Shopify.designMode) return;
  try {
    (function () {
    var MEDIA_QUERY = '(min-width: 1150px) and (hover: hover) and (pointer: fine)';
    var lastSlide = null;

    function canHover() {
      return window.matchMedia && window.matchMedia(MEDIA_QUERY).matches;
    }

    document.addEventListener(
      'mouseover',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;

        var slide = target.closest('.hdt-product-media__thumb .hdt-slider__slide');
        if (!slide || slide === lastSlide) return;

        var gallery = slide.closest('[data-thumb-hover="true"]');
        if (!gallery) return;
        if (!canHover()) return;

        lastSlide = slide;

        // Already showing: nothing to do.
        if (slide.classList.contains('is-thumb-selected')) return;

        // Gallery media on this theme can be tied to a variant. Moving to one
        // of those also switches the selected variant and the price, so a hover
        // would silently re-price the product. Preview only the media that are
        // not variant-linked; those still need a deliberate click.
        var thumbs = gallery.querySelectorAll('.hdt-product-media__thumb .hdt-slider__slide');
        var mains = gallery.querySelectorAll('.hdt-product-media__main .hdt-product__media-item');
        var index = Array.prototype.indexOf.call(thumbs, slide);
        var main = mains[index];
        if (!main || main.hasAttribute('data-variants-id')) return;

        // The thumb slider listens for clicks on the slide, so reuse its own
        // path rather than reaching into its internals.
        slide.click();
      },
      { passive: true }
    );

    document.addEventListener(
      'mouseout',
      function (event) {
        if (!event.relatedTarget || !event.relatedTarget.closest) {
          lastSlide = null;
          return;
        }
        if (!event.relatedTarget.closest('.hdt-product-media__thumb')) lastSlide = null;
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["so-delivery-nudge"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__soNudge) return;
  window.__soNudge = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var ALERT = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" aria-hidden="true"><path d="M12 7v6M12 17h.01"/></svg>';

  /* The confirmation shows INSIDE the delivery line (owner 2026-10-31), never floating over the
     cart or Check out: the line turns green with a check for a moment, then fades back to the next
     goal. The cart re-renders after an add, so the message waits for the fresh line to arrive. */
  function flash(box, html, bad) {
    if (!box || box.querySelector('.so-nudge__flash')) return;
    var line = box.querySelector('.so-nudge__line') || box;
    var el = document.createElement('span');
    el.className = 'so-nudge__flash';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    // The strings are this theme's own translations; the fee sits in .hdt-money so the store's
    // dirham-symbol script decorates it like every other price.
    el.innerHTML = '<span class="so-nudge__flash-ico">' + (bad ? ALERT : CHECK) + '</span><span class="so-nudge__flash-txt">' + html + '</span>';
    line.appendChild(el);
    box.classList.add(bad ? 'is-flash-bad' : 'is-flash');
    setTimeout(function () {
      box.classList.add('is-flash-out');
      setTimeout(function () { el.remove(); box.classList.remove('is-flash', 'is-flash-bad', 'is-flash-out'); }, 320);
    }, 2600);
  }

  function flashFresh(html) {
    var tries = 0;
    var t = setInterval(function () {
      var fresh = [].slice.call(document.querySelectorAll('div.so-nudge:not([data-stale])'));
      if (fresh.length || ++tries > 40) {
        clearInterval(t);
        fresh.forEach(function (box) { flash(box, html); });
      }
    }, 120);
  }

  function strings() {
    var s = window.soNudgeStrings || {};
    return { fee: s.fee || 'Added. Delivery is now AED 15.', free: s.free || 'Added. Delivery is now free.', plain: s.plain || 'Added to your cart.', error: s.error || 'Could not add this item. Please try again.' };
  }

  function refreshPage(box) {
    var sec = box.closest('.shopify-section');
    if (!sec || !sec.id) return Promise.resolve();
    var id = sec.id.replace(/^shopify-section-/, '');
    // On /cart, "?sections=" with a JSON Accept answers with the cart itself; section_id returns the HTML.
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById(sec.id);
        if (next) sec.innerHTML = next.innerHTML;
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-so-nudge-add]');
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var host = b.closest('[data-so-nudge]');
    var mid = parseInt(host && host.dataset.mid, 10) || 0;
    var free = parseInt(host && host.dataset.free, 10) || 30000;
    var s = strings();
    b.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.dataset.variant, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        [].forEach.call(document.querySelectorAll('div.so-nudge'), function (n) { n.setAttribute('data-stale', ''); });
        flashFresh(total >= free ? s.free : mid > 0 && total >= mid ? s.fee : s.plain);
        var page = host && host.dataset.place === 'page' ? refreshPage(host) : Promise.resolve();
        return page.then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); });
      })
      .catch(function () {
        b.removeAttribute('aria-busy');
        [].forEach.call(document.querySelectorAll('div.so-nudge'), function (n) { flash(n, s.error, true); });
      });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
